import { Injectable } from '@angular/core';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, take } from 'rxjs/operators';
import { Observable, of, BehaviorSubject, interval } from 'rxjs';
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';
import { UserIdleService } from './idle/angular-user-idle.service';
import { CasinoPlayerService } from './casino-player.service';
import { HttpService } from './http.service';
import { CryptoconvertService } from './cryptoconvert.service';
import * as moment from 'moment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UseridleComponent } from 'modules/shared/legacy-bookexpress/components/loyaltycalendar/useridle/useridle.component';

@Injectable()
export class ValidateLoyaltyService implements CanActivate {
  public tenantId: any;
  public propertyId: any;
  public casinoPlayerDetails = new BehaviorSubject('default');
  public playerDetails: any;
  public server_name: any;
  isConfirmationPage: boolean = false;
  interval1: any;
  counter: any = 0;
  public GUIDdata: any;
  public property_name: any;
  public customSessionTimeoutPage: any;
  //TS Venetian change
  public futureReservations: any;
  public tierDetails: any;
  arrivalBlockDateArray = [];
  departureBlockDateArray = [];
  restrictedDateArray = [];
  restrictedDateArrayGetDate = [];
  public offerDateRangeDetails = [];
  public isOfferStartDateEndDateAvailable: boolean = false;

  constructor(
    public AppInitializer: LegacyBookInitService,
    public googleAnalytics: GoogleAnalyticsEventsService,
    public cryptoConvert: CryptoconvertService,
    public CasinoPlayerService: CasinoPlayerService,
    public router: Router,
    private userIdle: UserIdleService,
    private dialog: MatDialog,
    private _http: HttpClient,
    public httpService: HttpService,
    public googlanalytics: GoogleAnalyticsEventsService
  ) {
    this.server_name = AppInitializer.getserverDetails_loyalty();
    this.tenantId = AppInitializer.tenantId;
    this.propertyId = AppInitializer.propertyId;
    this.property_name = AppInitializer.PropertyData.PropNameKeyList.loyalty;
    this.customSessionTimeoutPage = AppInitializer.PropertyData.permissions.functionalPermissions.customSessionTimeoutPage;
    //Start watching for user inactivity.

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe((count) => {
      console.log(count);
      if (count == 1) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          timeout: Number(this.AppInitializer.PropertyData.warningTime) - count,
          name: this.playerDetails?.firstName + ' ' + this.playerDetails?.lastName,
          isConfirmationPage: this.isConfirmationPage,
        };
        this.counter = count;
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        let warningTime = this.AppInitializer.PropertyData.warningTime;
        const dialogref = this.dialog.open(UseridleComponent, dialogConfig);
        const interval$ = interval(1000);
        const example = interval$.pipe(take(Number(warningTime)));
        var subscription = example.subscribe((data) => {
          console.log(data);
          if (this.counter === Number(warningTime) - 1) {
            subscription.unsubscribe();
            dialogref.close();
          }
          if (this.counter > 0) {
            this.counter = this.counter + 1;
            dialogref.componentInstance.timeout = Number(warningTime) - this.counter;
          }
        });

        dialogref.afterClosed().subscribe((close) => {
          subscription.unsubscribe();
          if (close == 'proceedtoWork') {
            this.stop();
          } else if (close == 'logout') {
            localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-GuestLayout');
            localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-cart');
            localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-validEnhancedata');
            if (this.customSessionTimeoutPage) {
              this.router.navigate(['/wbe/session-timeout/' + this.tenantId + '/' + this.propertyId]);
            } else {
              window.location.href = this.AppInitializer.PropertyData.UrlMap.redirectUserOnConfirmationUrl;
            }
          }
        });
      }
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      console.log('Time is up!');
      if (this.customSessionTimeoutPage) {
        this.router.navigate(['/wbe/session-timeout/' + this.tenantId + '/' + this.propertyId]);
      } else {
        window.location.href = this.AppInitializer.PropertyData.UrlMap.redirectUserOnConfirmationUrl;
      }
    });
  }

  canActivate(route: ActivatedRouteSnapshot) {
    return this.ValidateGUID(route.params['guid']);
  }

  ValidateGUID(guid): Observable<boolean> {
    if (!this.GUIDdata) {
      let url =
        this.AppInitializer.getCloudDomainName() +
        '/' +
        this.server_name +
        '/tenants/' +
        this.tenantId +
        ('/context/' + this.AppInitializer.PropertyData.ContextId + '/') +
        'propertyId/' +
        this.propertyId +
        '/propertyName/' +
        this.AppInitializer.PropertyData.PropNameKeyList.loyalty +
        '/loyaltyProgram/casino?appName=wbe&locale=' +
        this.AppInitializer.langCode;
      let headers = JSON.parse(JSON.stringify(this.AppInitializer.serviceHeaders));
      headers.headers['guId'] = guid;
      return this.httpService.get(url, headers).pipe(
        map((response) => {
          console.log(response);
          if (response['success']) {
            this.AppInitializer.isCasinoLoggedWithGuid = true;
            if (this.AppInitializer.guestLoginFlow === 'SSO') {
              this.GUIDdata = response['propertyDetails'];
              sessionStorage.setItem(this.tenantId + '-' + this.propertyId + '-loyaltyOfferData', JSON.stringify(this.GUIDdata));
              let casinoDetails = response['casinoDetails'].casinoPlayerDetails;
              //Venetian TS change
              let tier = response['casinoDetails'].casinoPlayerDetails.tier;
              let futureRes = response['casinoDetails'].casinoPlayerDetails.futureReservations;
              //Venetian TS change
              casinoDetails.casinoNumber = response['casinoDetails'].casinoId;
              this.casinoPlayerDetails.next(casinoDetails);
              this.playerDetails = casinoDetails;
              //Venetian TS change
              this.tierDetails = tier;
              this.futureReservations = futureRes;
              if (response['propertyDetails'].length > 0) {
                for (let i = 0; i < response['propertyDetails'].length; i++) {
                  if (response['propertyDetails'][i].offers.offerStart && response['propertyDetails'][i].offers.offerEnd) {
                    let offerAllowedDatesArrayGetDate = [];
                    let offerStartDate = moment(response['propertyDetails'][i].offers.offerStart).format('YYYY-MM-DDTHH:mm:ss');
                    let offerEndDate = moment(response['propertyDetails'][i].offers.offerEnd).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss');
                    for (let d = new Date(offerStartDate); d <= new Date(offerEndDate); d.setDate(d.getDate() + 1)) {
                      offerAllowedDatesArrayGetDate.push(moment(d).format('YYYY-MM-DD'));
                    }

                    this.offerDateRangeDetails.push({
                      startDate: offerStartDate,
                      endDate: offerEndDate,
                      offerCode: response['propertyDetails'][i].offers.offer,
                      offerDateRange: offerAllowedDatesArrayGetDate,
                    });
                    this.isOfferStartDateEndDateAvailable = true;
                  }
                }
              }
              //Venetian TS change
              localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-GuestLayout');
              localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-cart');
              localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-validEnhancedata');
              if (this.AppInitializer.PropertyData.hasLoyaltyTimeout) this.startWatching();
              return response['success'];
            } else if (this.AppInitializer.guestLoginFlow === 'Combined') {
              let data = {
                casinoNumber: response['casinoDetails'].casinoId,
                token: 1,
              };
              localStorage.setItem(this.tenantId + '-' + this.propertyId + '-Casino', JSON.stringify(data));
              this.CasinoPlayerService.updateCasinoPopUp(response['casinoDetails'].casinoPlayerDetails);
              let offerCode;
              offerCode = this.AppInitializer.defaultOffer();
              if (response['propertyDetails'].length > 0 && response['propertyDetails'][0].offers) {
                offerCode = response['propertyDetails'][0].offers.offer ? response['propertyDetails'][0].offers.offer : offerCode;
              }
              if (this.AppInitializer.PropertyData.permissions.functionalPermissions.encryptOfferCodeinURL) {
                offerCode = this.cryptoConvert.convertOfferCode(offerCode, 'encrypt');
              }
              this.AppInitializer.PropertyData.permissions.routePermissions.loyalty = false;
              this.router.navigate(['/wbe/calendar/' + this.tenantId + '/' + this.propertyId + '/' + offerCode]);
              return false;
            } else {
              if (this.customSessionTimeoutPage) {
                this.router.navigate(['/wbe/session-timeout/' + this.tenantId + '/' + this.propertyId]);
              } else {
                window.location.href = this.AppInitializer.PropertyData.UrlMap.CustomerWebsiteUrl;
              }
              return false;
            }
          } else {
            localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-GuestLayout');
            localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-cart');
            localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-validEnhancedata');
            if (this.customSessionTimeoutPage) {
              this.router.navigate(['/wbe/session-timeout/' + this.tenantId + '/' + this.propertyId]);
            } else {
              window.location.href = this.AppInitializer.PropertyData.UrlMap.unAuthRedirectUrl;
            }
          }
        })
      );
    } else {
      sessionStorage.setItem(this.tenantId + '-' + this.propertyId + '-loyaltyOfferData', '');
      return of(true);
    }
  }

  getFutureReservationDates() {
    this.tierDetails = this.playerDetails.tier;
    let futureReservations = this.futureReservations;

    for (var i = 0; i < futureReservations?.length; i++) {
      var arrivalBlockDate = new Date(futureReservations[i].arrival);
      futureReservations[i].bufferBefore = !futureReservations[i].bufferBefore ? 0 : futureReservations[i].bufferBefore;
      arrivalBlockDate.setDate(arrivalBlockDate.getDate() - futureReservations[i].bufferBefore);
      this.arrivalBlockDateArray.push(arrivalBlockDate);

      var departureBlockDate = new Date(futureReservations[i].departure);
      futureReservations[i].bufferAfter = !futureReservations[i].bufferAfter ? 0 : futureReservations[i].bufferAfter;
      departureBlockDate.setDate(departureBlockDate.getDate() + parseInt(futureReservations[i].bufferAfter));
      this.departureBlockDateArray.push(departureBlockDate);
      for (var d = new Date(arrivalBlockDate); d <= departureBlockDate; d.setDate(d.getDate() + 1)) {
        this.restrictedDateArray.push(new Date(d));
        this.restrictedDateArrayGetDate.push(moment(d).format('YYYY-MM-DD'));
      }
    }
  }

  //TS Venetian change

  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
